module.exports = __webpack_public_path__ + "img/nh3-emissions.2cd77661.png";